import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";

import NoDataCreated from "../../Components/NoDataCreated";
import ErrorPage from "../../Components/ErrorPage";
import PageLoader from "../../Components/PageLoader";
import { goToTop } from "../../Components/goToTop";
import { getLoginUserRoleName, UserRoleName } from "../../Utils/LoginUserRoleName";

import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";

import {
    QuotationList as QuotationListType,
    Quotation as QuotationType
} from "../../Controllers/Types/Quotation/QuotationType";
import QuotationReportConfigModal from "./QuotationReportConfigModal";

// import { ContactList, contactLists } from "../Project/DefaultService/PreCommencement/DutyHolderDetails/SampleData";

import { fetchQuotationData } from "../../Controllers/Thunks/QuotationThunks";

import ShareModal from "../../Components/ShareModal";
import { mapShareContactType, ShareContactType } from "../../Controllers/Types/Share/ShareContactType";
import { shareQuotations } from "../../Api/Quotation/QuotationApiService";
import SharedByAvatar from "../../Components/SharedByAvatar";


const QuotationList: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef<Toast>(null);
    const dispatch = useAppDispatch();
    const [loginUserRoleName, setLoginUserRoleName] = useState<UserRoleName | ''>('');
    const [loading, setLoading] = useState<boolean>(false);
    const [createLoading, setCreateLoading] = useState<boolean>(false);

    const globalQuotation: QuotationType | null = location?.state?.quotation;
    const [quotation, setQuotation] = useState<QuotationType | null>(null);

    const loadingQuotation: boolean = useAppSelector((state) => state?.quotationList?.loadingQuotation);
    // const quotations: QuotationType[] = useAppSelector((state) => state?.quotationList?.quotations);
    const errorQuotation: string | null = useAppSelector((state) => state?.quotationList?.errorQuotation);

    const [showQuotationViewOptionModal, setShowQuotationViewOptionModal] = useState<boolean>(false);
    const [quotationViewOption, setQuotationViewOption] = useState<'Simple' | 'Detail' | null>(null);
    const [showReportConfigModal, setShowReportConfigModal] = useState<boolean>(false);

    const [quotationListData, setQuotationListData] = useState<QuotationListType[]>([]);
    const [selectedQuotationList, setSelectedQuotationList] = useState<QuotationListType | null>(null);
    const [quotationListFilterState, setQuotationListFilterState] = useState<'All' | 'Draft' | 'Complete'>('All');

    const [isSimpleReportSigned, setIsSimpleReportSigned] = useState<boolean>(false);
    const [isSimpleReportGenerated, setIsSimpleReportGenerated] = useState<boolean>(false);
    const [isDetailReportSigned, setIsDetailReportSigned] = useState<boolean>(false);
    const [isDetailReportGenerated, setIsDetailReportGenerated] = useState<boolean>(false);

    const contactListBodyRef = useRef<HTMLDivElement>(null);
    // for share
    const [showContactShareModal, setShowContactShareModal] = useState<boolean>(false);

    // shared list

    const [sharedList, setSharedList] = useState<ShareContactType[]>([]);


    /* PERMISION HANDLER */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) =>
            hasPermission(state, screen, permission)
        );
    };

    // Get logged in user role name
    useEffect(() => {
        const fetchUserRole = async () => {
            const roleName = await getLoginUserRoleName();
            setLoginUserRoleName(roleName);
        };

        fetchUserRole();
    }, []);

    // get from database 

    useEffect(() => {
        dispatch(fetchQuotationData());
    }, [dispatch]);

    // this is get data from state list and set projectlist
    const quatations = useAppSelector((state) => state.quotationList.quotations);

    useEffect(() => {
        const list = quatations.filter(
            (e) => e.id === globalQuotation?.id
        );
        if (list?.length > 0) {
            setQuotation(list[0] as QuotationType);

            // if (list[0].shared_by === null) {
            //     setQuotationListFilterState('All');
            // } else {
            //     setQuotationListFilterState('Complete');

            // }



        }

    }, [quatations]);


    useEffect(() => {
        if (quotation && quotation !== null) {
            const quotationList = quotation?.quotation_data;

            let filteredData: QuotationListType[] = [];

            if (quotationListFilterState === 'All') {
                filteredData = quotationList
            } else {
                filteredData = quotationList?.filter(data => data?.status === quotationListFilterState);
            }

            setQuotationListData(filteredData);
        } else {
            setQuotationListData([]);
        }
    }, [quotation, quotationListFilterState]);

    useEffect(() => {
        if (selectedQuotationList && selectedQuotationList !== null) {
            setIsSimpleReportSigned(selectedQuotationList?.sign_report === 1 ? true : false);
            setIsSimpleReportGenerated(selectedQuotationList?.generate_report === 1 ? true : false);
            setIsDetailReportSigned(selectedQuotationList?.detail_sign_report === 1 ? true : false);
            setIsDetailReportGenerated(selectedQuotationList?.detail_generate_report === 1 ? true : false);
        } else {
            setIsSimpleReportSigned(false);
            setIsSimpleReportGenerated(false);
            setIsDetailReportSigned(false);
            setIsDetailReportGenerated(false);
        }
    }, [selectedQuotationList]);

    const handleChangeQuotationListFilterState = (state: 'All' | 'Draft' | 'Complete') => {
        setQuotationListFilterState(state);
    }

    const handleViewQuotationDetail = (quotationList: QuotationListType) => {
        const isReportSigned: boolean = quotationList?.sign_report === 1 ? true : false;
        const isReportGenerated: boolean = quotationList?.generate_report === 1 ? true : false;
        setSelectedQuotationList(quotationList);
        // handleShowQuotationViewOption();
        if (quotationList.detail_sign !== null) {
            navigate(`/quotation/report`, {
                state: {
                    quotationNo: quotation?.quotation_no,
                    quotationDetail: quotationList,
                    reportType: "Detail",
                    quotation: quotation,
                    reportView: (quotationList.detail_permission_data && quotationList.detail_permission_data != null) ? quotationList.detail_permission_data.permission_list : [],
                    headerContent: (quotationList.detail_permission_data && quotationList.detail_permission_data != null) ? quotationList.detail_permission_data.header : null,
                    footerContent: (quotationList.detail_permission_data && quotationList.detail_permission_data != null) ? quotationList.detail_permission_data.footer : null,
                }
            });
            // details report
        } else if (quotationList.sign !== null) {
            // simple report

            navigate(`/quotation/report`, {
                state: {
                    quotationNo: quotation?.quotation_no,
                    quotationDetail: quotationList,
                    reportType: "Simple",
                    quotation: quotation,
                    reportView: (quotationList.simple_permission_data && quotationList.simple_permission_data != null) ? quotationList.simple_permission_data.permission_list : [],
                    headerContent: (quotationList.simple_permission_data && quotationList.simple_permission_data != null) ? quotationList.simple_permission_data.header : null,
                    footerContent: (quotationList.simple_permission_data && quotationList.simple_permission_data != null) ? quotationList.simple_permission_data.footer : null,
                }
            });
        } else {
            navigate(`/quotation/detail`, {
                state: {
                    quotationNo: quotation?.quotation_no,
                    quotationDetail: quotationList,
                    quotation: quotation
                }
            })
        }

    }


    // refill shared list data
    useEffect(() => {
        if (!selectedQuotationList) return;
        const shareList = selectedQuotationList.share_list ?? [];
        if (shareList.length > 0) {
            const results: ShareContactType[] = shareList.map((e) => {
                const dt: Partial<ShareContactType> = {
                    id: e.id,
                    first_name: e.first_name,
                    last_name: e.last_name!,
                    profile_image: e.profile_image,
                    email: e.email!,
                    type: e.main_type!,
                    by: e.by,
                    can_edit: e.can_edit,
                    can_view: 1, // forcing as "viewable"
                };

                return mapShareContactType(dt);
            });

            setSharedList(results);
        } else {
            setSharedList([]); // clear if no share list
        }
    }, [selectedQuotationList]);

    /* Share  */
    const handleCloseShareModal = () => {
        setShowContactShareModal(false);
    }

    const handleShareQuotation = (quotationList: QuotationListType) => {
        setShowContactShareModal(true);
        setSelectedQuotationList(quotationList);
    }

    // database function
    const shareQuotation = async (selectedContacts: ShareContactType[]) => {
        // get only ticked data as well
        const sendData = selectedContacts.filter((e) => e.can_view != 0 || e.can_edit != 0)

        if (sendData && sendData?.length > 0) {
            const data = await shareQuotations(
                selectedQuotationList?.id!,
                sendData

            );
            if (data.statusCode === 200) {
                setLoading(false);
                handleCloseShareModal();
                dispatch(fetchQuotationData());

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Quotation shared successfully.',
                        life: 3000
                    });
                }
            } else {
                setLoading(false);
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'There was an error sharing the quotation.',
                        life: 3000
                    });
                }
            }
        }
    }
    /*  */

    const handleShowQuotationViewOption = () => {
        setShowQuotationViewOptionModal(true);
    }

    const handleCloseQuotationViewOptionModal = () => {
        setShowQuotationViewOptionModal(false);
        setQuotationViewOption(null);
    }

    const handleSelectQuotationViewOption = (option: 'Simple' | 'Detail') => {
        if (option === 'Simple') {
            if (isSimpleReportSigned && isSimpleReportGenerated) {
                navigate(`/quotation/report`, {
                    state: {
                        quotationNo: quotation?.quotation_no,
                        quotationDetail: selectedQuotationList,
                        reportType: option
                    }
                });
            } else {
                setShowReportConfigModal(true);
                setShowQuotationViewOptionModal(false);
            }
        }

        if (option === 'Detail') {
            if (isDetailReportSigned && isDetailReportGenerated) {
                navigate(`/quotation/report`, {
                    state: {
                        quotationDetail: selectedQuotationList,
                        reportType: option
                    }
                });
            } else {
                setShowReportConfigModal(true);
                setShowQuotationViewOptionModal(false);
            }
        }
    }

    const quotationReportOptionModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Report options
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseQuotationViewOptionModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    const quotationReportOptionModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseQuotationViewOptionModal}
            />

            <Button
                label={'Continue'}
                onClick={() => handleSelectQuotationViewOption(quotationViewOption!)}
                loading={createLoading}
                className="custom_btn primary"
                disabled={quotationViewOption === null}
            />
        </div>
    );

    const handleCloseReportConfigModal = () => {
        setShowReportConfigModal(false);
        setShowQuotationViewOptionModal(true);
    }


    /* For table data view */
    const statusBody = (rowData: QuotationListType) => {
        const status = rowData.status;
        let color = "";
        let bgColor = "";

        if (status === 'Draft') {
            color = "#656565";
            bgColor = "#EEE";
        } else if (status === 'Complete') {
            color = "#06b500";
            bgColor = "#d5f8df";
        }

        return (
            <div className="flex_center">
                <span className="priority_label lg" style={{ color: color, backgroundColor: bgColor }}>
                    {status === 'Complete' ? 'Completed' : status}
                </span>
            </div>
        );
    };

    const tableActionBody = (rowData: QuotationListType) => {
        return (
            <React.Fragment>
                <div className={`table_action_btn_area justify-content-end mt-1 mb-1`}>
                    <button
                        className="table_action_btn fixed_width p-ripple"
                        onClick={() => handleViewQuotationDetail(rowData)}
                    >
                        View
                        <Ripple />
                    </button>

                    {quotation?.type === 'Own' && (
                        <button
                            className="table_action_btn fixed_width p-ripple"
                            onClick={() => handleShareQuotation(rowData)}
                        >
                            Share
                            <Ripple />
                        </button>
                    )}
                </div>
            </React.Fragment>
        )
    }

    const sharedContactBody = (rowData: QuotationListType) => {
        return (
            <SharedByAvatar
                avatarKey={rowData?.shared_by?.id}
                firstName={rowData?.shared_by?.first_name}
                lastName={rowData?.shared_by?.last_name}
                profileImage={rowData?.shared_by?.profile_image}
            />
        );
    };
    /*  */

    /* **************************** Common functions ***************************** */
    const goBack = () => {
        navigate(-1);
        goToTop();
    };
    /* *************************************************************************** */

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingQuotation ? (
                    <PageLoader />
                ) : errorQuotation ? (
                    <ErrorPage errorMessage={errorQuotation} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    Quotation
                                </li>

                                <li className="page_breadcrumb_item active">
                                    Quotation {quotation ? String(quotation?.quotation_no).padStart(2, '0') : ''}&nbsp;({quotation?.project_address})
                                </li>
                            </ul>
                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-sm-3 mt-3">
                            <div className="contact_tabs">

                                {/* {(quotation?.shared_by == null) && ( */}
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width ${quotationListFilterState === "All" ? "active" : ""} p-ripple`}
                                        onClick={() => handleChangeQuotationListFilterState('All')}
                                    >
                                        All
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                                {/* )} */}


                                {/* {(quotation?.shared_by == null) && ( */}
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width ${quotationListFilterState === "Draft" ? "active" : ""} p-ripple`}
                                        onClick={() => handleChangeQuotationListFilterState("Draft")}
                                    >
                                        Draft
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                                {/* )} */}


                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width ${quotationListFilterState === "Complete" ? "active" : ""} p-ripple`}
                                        onClick={() => handleChangeQuotationListFilterState("Complete")}
                                    >
                                        Completed
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="page_main_content_section no_header">
                            {quotationListData && quotationListData?.length > 0 ? (
                                <DataTable
                                    value={quotationListData}
                                    paginator
                                    rows={10}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    paginatorDropdownAppendTo={'self'}
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    size="small"
                                    tableStyle={{ minWidth: "50rem" }}
                                    className="page_table p-0 p-sm-2"
                                    rowHover
                                    scrollable
                                    dataKey="id"
                                >
                                    <Column
                                        header="Quotation"
                                        headerClassName="text_purple"
                                        body={(rowData: QuotationListType) => (
                                            <span className="text_bold note_column">
                                                {rowData.quotation_no ? rowData.quotation_no : "---"}
                                            </span>
                                        )}
                                        style={{ width: "40%" }}
                                    ></Column>

                                    <Column
                                        header="Date"
                                        headerClassName="text_purple "
                                        body={(rowData: QuotationListType) => (
                                            <span className="text_no_wrap">
                                                {rowData.date ? rowData.date : "---"}
                                            </span>
                                        )}
                                        style={{ width: "15%" }}
                                    ></Column>

                                    {quotationListFilterState === 'All' && (
                                        <Column
                                            header="Status"
                                            alignHeader={"center"}
                                            headerClassName="text_purple"
                                            body={statusBody}
                                            style={{ width: "15%" }}
                                        ></Column>
                                    )}

                                    {quotation?.type === 'Shared' && (
                                        <Column
                                            body={sharedContactBody}
                                            header="Shared by"
                                            headerClassName="text_purple"
                                            alignHeader={'center'}
                                            style={{ width: "15%" }}
                                        ></Column>
                                    )}

                                    <Column
                                        body={tableActionBody}
                                        className="table_btn_area"
                                        frozen={window.innerWidth > 575}
                                        alignFrozen="right"
                                        style={{ width: "15%" }}
                                    ></Column>
                                </DataTable>
                            ) : (
                                <NoDataCreated
                                    message={`No ${quotationListFilterState === 'All' ? '' : quotationListFilterState === 'Complete' ? 'completed' : 'draft'} quotation data found!`}
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>

            {/* Quotation report view option modal */}
            <Dialog
                visible={showQuotationViewOptionModal}
                header={quotationReportOptionModalHeader}
                footer={quotationReportOptionModalFooter}
                headerClassName="custom_modal_header"
                className="custom_modal_dialog modal_dialog_xsm"
                onHide={handleCloseQuotationViewOptionModal}
                dismissableMask
                draggable={false}
            >
                <div className="custom_modal_body p-1 p-sm-0">
                    <div className="custom_option_btn_area">
                        <button className={`custom_pc_option_btn option ${quotationViewOption === 'Simple' ? 'selected' : ''} p-ripple`}
                            onClick={() => setQuotationViewOption('Simple')}>
                            <span>
                                <i className="bi bi-card-checklist me-2"></i>
                                Simple
                            </span>
                            <i className={`bi bi-check-circle-fill check_icon ${isSimpleReportGenerated ? 'success' : 'warning'}`}></i>
                            <Ripple />
                        </button>

                        <button className={`custom_pc_option_btn option ${quotationViewOption === 'Detail' ? 'selected' : ''} p-ripple`}
                            onClick={() => setQuotationViewOption('Detail')}>
                            <span>
                                <i className="bi bi-card-list me-2"></i>
                                Detail
                            </span>
                            <i className={`bi bi-check-circle-fill check_icon ${isDetailReportGenerated ? 'success' : 'warning'}`}></i>
                            <Ripple />
                        </button>
                    </div>
                </div>
            </Dialog>
            {/*  */}

            {/* Share modal */}
            <ShareModal
                isOpen={showContactShareModal}
                canEditOption={true}
                loading={loading}
                sharedList={sharedList}
                projectContactIds={[]}
                onClose={handleCloseShareModal}
                onShare={shareQuotation}
                title="Share Quotation"
            />
            {/*  */}

            {/* Quotation report config modal */}
            <QuotationReportConfigModal
                isOpen={showReportConfigModal}
                onClose={handleCloseReportConfigModal}
                toast={toast}
                reportTitle={quotationViewOption + ` report`}
                quotationNo={quotation?.quotation_no!}
                quotationDetail={selectedQuotationList}
                view={quotationViewOption!}
                quotation={quotation}
            />
            {/*  */}
        </React.Fragment>
    )
}

export default QuotationList;